import { render, staticRenderFns } from "./JgpLayoutBorderItem.vue?vue&type=template&id=3aabb103&"
import script from "./JgpLayoutBorderItem.vue?vue&type=script&lang=js&"
export * from "./JgpLayoutBorderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports